import TemplateColors from './TemplateColors';

const TemplateLightColorDefaultValues = {
  [TemplateColors.FIELD_BACKGROUND]: '#e6e6e6',
  [TemplateColors.HEADER_BACKGROUND]: '#ffffff',
  [TemplateColors.HEADER_FONT]: '#3d3d3d',
  [TemplateColors.TEXT_FONT]: '#3d3d3d',
};

export default TemplateLightColorDefaultValues;
